<template>
  <div class="modal-progress-preview-single-stdb-question">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container-outer">
          <ButtonClose
            class="modal-default-button"
            @click.native="$emit('close')"
          />
          <div
            ref="modalContainer"
            class="modal-container"
          >
            <div class="h-100 w-100 modal-contents-area">
              <div class="d-flex flex-column flex-fill modal-contents-area-inner">
                <div class="row">
                  <div
                    v-if="selectedHomeworkItemIndex !== 0"
                    class="col-2"
                  >
                    <div class="show-three-point">
                      No.{{ selectedHomeworkItemIndex }}
                    </div>
                  </div>
                  <div class="col-10">
                    <div class="show-three-point">
                      {{ item.taskName }}
                    </div>
                  </div>
                </div>
                <div class="preview-wrapper pt-2">
                  <PreviewContainer
                    ref="previewContainer"
                    :image="image"
                    :setting-list="settingList"
                    :stdb-flg="true"
                  />
                </div>
                <LoadingScreen v-if="isLoading" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalConfirmOkOnly
      v-if="showConfirmCaution"
      :message="cautionMessage"
      @close-confirm-modal-ok-only="closeModal"
    />
  </div>
</template>

<script>
/**
 * 宿題管理 - STDB一問ずつのプレビューモーダル
 */
import mixin from "@/mixins/mixin"
import ButtonClose from "@/components/atoms/buttons/ButtonClose.vue"
import PreviewContainer from "@/components/organisms/PreviewContainer.vue"
import LoadingScreen from "@/components/atoms/LoadingScreen.vue"
import homeworkRepository from "@/repositories/homework"
import { settingTabIdCode } from "@/constant/question"
import ModalConfirmOkOnly from "@/components/organisms/modal/ModalConfirmOkOnly.vue"

export default {
  name: "ModalProgressPreviewSingleStdbQuestion",
  components: {
    ButtonClose,
    PreviewContainer,
    LoadingScreen,
    ModalConfirmOkOnly,
  },
  mixins: [mixin],
  props: {
    item: {
      type: Object,
      require: true,
      default: function () {
        return {}
      },
    },
    selectedHomeworkItemIndex: {
      type: Number,
      default: function () {
        return 0
      },
    },
  },

  data: () => ({
    image: null,
    settingList: [],
    isLoading: false,
    cautionMessage: "",
    showConfirmCaution: false,
  }),
  async mounted() {
    // リサイズ時にモーダルサイズの調整を行う（iPad対応）
    window.addEventListener('resize', () => {
      this.adjustModal();
    });
    this.adjustModal();

    this.settingList = []

    let fileList = this.item.fileList
      ? this.item.fileList.map((file) => {
          return {
            fileName: file.file_name,
            filePath: file.file_image,
          }
        })
      : []
    if (fileList.length === 0) {
      this.isLoading = true
      try {
        fileList = await this.fetchFileList()
      } catch (error) {
        // メッセージ出力
        if (this.item.isPublished) {
          this.showModalOkOnly(
            this.$t("messages.error.uploadPublicEndPreviewForPublish")
          )
        } else {
          this.showModalOkOnly(this.$t("messages.error.uploadPublicEndPreview"))
        }
        this.isLoading = false
        return
      }
    }

    fileList.forEach((info) => {
      const prefix = info.fileName[0]
      switch (prefix) {
        case "Q":
          this.image = info.filePath
          break
        case "A":
          this.appendToSettingList(
            settingTabIdCode.answerId,
            info.filePath,
            prefix
          )
          break
        case "E":
          this.appendToSettingList(
            settingTabIdCode.explainId,
            info.filePath,
            prefix
          )
          break
      }
    })

    if (this.settingList.length > 0) {
      // IDの順に並べ替え、一番左のものを選択
      this.settingList.sort((a, b) => (a.id > b.id ? 1 : -1))
      this.$set(
        this.$refs.previewContainer,
        "currentId",
        this.settingList[0].id
      )
      this.$refs.previewContainer.initializeId()
    }

    this.isLoading = false
  },
  methods: {
    /**
     * モーダルサイズ調整
     */
    adjustModal() {
      var e = this.$refs.modalContainer;
      if (e) {
        var v = window.innerHeight;
        e.style.height = `${ (v - 20) }px`;
      }
    },

    /**
     * ファイルリストを取得
     */
    fetchFileList: async function () {
      return await homeworkRepository.getHomeworkStreamFileListForStdbPreview(
        this.loginUserInfo.accountId,
        this.loginUserInfo.schoolId,
        this.item.mode,
        this.item.key,
        this.item.keyNo,
        this.item.fileNmSeq,
        this.loginUserInfo.lmsApiToken
      )
    },
    /**
     * settingListに画像情報を追加
     */
    appendToSettingList: function (id, filePath, prefix) {
      let label = ""
      switch (prefix) {
        case "A":
          label = this.$t("labels.answer")
          break
        case "E":
          label = this.$t("labels.explanation")
          break
      }
      const item = {
        content: filePath,
        id: id,
        label: label,
      }
      this.settingList.splice(0, 0, item)
    },
    /*
     * 閉じるモーダル
     */
    closeModal: function () {
      this.showConfirmCaution = false
      this.$emit("close")
    },

    /**
     * OKだけのモーダルを表示する
     */
    showModalOkOnly: function (message) {
      this.cautionMessage = message
      this.showConfirmCaution = true
    },
  },
}
</script>

<style lang="scss" scoped>
.show-three-point {
  max-width: fit-content;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;

    .modal-container-outer {
      width: 100%;
      margin-left: auto;
      margin-right: auto;

      .modal-default-button {
        position: absolute;
        left: calc(100vw - 50px);
      }

      .modal-container {
        position: relative;
        width: calc(100vw - 100px);
        height: calc(100vh - 20px);
        margin: auto;
        padding: 15px;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        .modal-contents-area {
          display: flex;
          flex-direction: column;
          .modal-contents-area-inner {
            height: 100%;
          }
        }
      }
    }
  }
}

.preview-wrapper {
  min-height: 0;
  flex: 1;
}
</style>
